import { Breakpoint } from "@material-ui/core/styles/createBreakpoints";

export const layoutBreakpoint: Breakpoint = "sm";
export const rootFontSize = 16;

export const cssVars = {
  toolbarMenuButtonWidth: 48 / rootFontSize,
  toolbarPaddingLeft: 24 / rootFontSize,
  webStepperMinWidth: 250 / rootFontSize,
  webToolbarHeight: 150 / rootFontSize,
  drawerWidth: 260 / rootFontSize
};

export const customBoxShadow =
  "0 0.25rem 0.625rem 0 rgba(0, 0, 0, 0.2), 0.25rem 0 0.5rem 0 rgba(0, 0, 0, 0.14), -0.25rem 0 0.5rem 0 rgba(0, 0, 0, 0.12);";
